import { Col, Row } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { UpdateTemplate } from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import editIco from "../../assets/icons/TemplateBuilder/edit.svg";
import deleteIco from "../../assets/icons/TemplateBuilder/Bin.svg";
import Duplicate from "../../assets/icons/TemplateBuilder/Duplicate blur.svg";
import { useHistory } from "react-router-dom";
import {
  deleteTemplateById,
  DuplicateTemplate,
} from "../../redux/actions/action";
import TemplateBuilderIcon from "../../assets/icons/TemplateBuilder.svg";

const TemplateTableList = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isProduction = localStorage.getItem("workspaceName") === "production";

  const templateData = props.data || [];
  const grapesTemplateData = props.grapesTemplates || [];
  const templates = [
    ...templateData.map((template) => ({ ...template, isGrapesTemplate: false })),
    ...grapesTemplateData.map((template) => ({
      ...template,
      templateId: template.id || template.templateId,
      isGrapesTemplate: true,
    })),
  ];
  const eventLabel = (template) =>
    template?.eventName ||
    template?.event?.eventName ||
    template?.event?.name ||
    template?.eventKey ||
    template?.event?.eventKey;
  const templateSource = (template) =>
    template?.templateSource || template?.source || (template?.isSystem ? "System" : "");

  const makeTemplateDefaultRes = useSelector(
    (state) => state.user.makeTemplateDefaultRes,
  );

  const deleteTemplate = (templateId) => {
    deleteTemplateById(templateId).then((o) => {
      props.refreshData();
    });
  };

  const duplicateTemplate = (templateId) => {
    dispatch(DuplicateTemplate({ templateId: templateId })).then((o) => {
      props.refreshData();
    });
  };

  // const [isDefaultTemplate, setIsDefaultTemplate] = useState(false);
  const [templateID, setTemplateID] = useState("");

  useEffect(() => {
    if (templateData.length > 0) {
      const defaultTemplate = templateData.find(
        (item) => item.isdefault === true && item.isSystem === false,
      );
      if (defaultTemplate) {
        setTemplateID(defaultTemplate.templateId);
      }
    }
  }, [templateData]);

  // console.log("asc33", isDefaultTemplate);

  return (
    <>
      <div style={{ width: "50%" }} className="ps-4">
        <Row className="border-bottom mb-2 border_bottom_minwid">
          <Col xl={6} md={6} sm={6} className="template-list-header">
            {props.header || "Templates"}
          </Col>
          <Col xl={6} md={6} sm={6} className="text-end d-none">
            1-2 of 1
          </Col>
        </Row>
        {templates.length > 0 &&
          templates.map((o) => (
            <Row
              className="border-bottom-dotted"
              key={o.templateId}
              style={{
                display:
                  isProduction &&
                  o?.isSystem === true &&
                  o?.isdefault === true &&
                  "none",
              }}
            >
              <Col xl={6} md={6} sm={6} className="d-flex align-items-center">
                {!o.isGrapesTemplate && (
                  <input
                    type="radio"
                    checked={templateID === o.templateId}
                    className="me-2 pointer"
                    style={{
                      visibility:
                        o?.isSystem === true && o?.isdefault === true && "hidden",
                      fontSize: "12px",
                      width: "20px",
                      height: "20px",
                    }}
                    onChange={() => {
                      setTemplateID(o.templateId);
                      dispatch(UpdateTemplate(o.templateId, true));
                    }}
                  />
                )}
                <img
                  src={TemplateBuilderIcon}
                  className="template-icon cursor-pointer"
                  alt="template"
                />{" "}
                &nbsp;
                <div>
                  <div>{eventLabel(o) ? `${eventLabel(o)} — ${o.templateName}` : o.templateName}</div>
                  {templateSource(o) && (
                    <small style={{ color: "#697386" }}>
                      {templateSource(o) === "WorkspaceCustom" ? "Workspace custom template" : "System template"}
                    </small>
                  )}
                </div>
              </Col>
              <Col xl={6} md={6} sm={6} className="text-end">
                {!(o.isGrapesTemplate && templateSource(o) === "System" && props.readOnlySystemTemplates) && <img
                  src={editIco}
                  alt="Edit"
                  className="cursor-pointer"
                  onClick={() =>
                    history.push(
                      `${o.isGrapesTemplate ? props.grapesEditRoute : props.editRoute}${o.templateId}`,
                    )
                  }
                />} {" "}
                {o.isGrapesTemplate && templateSource(o) === "System" && props.onCreateWorkspaceOverride && (
                  <button className="btn btn-link btn-sm" onClick={() => props.onCreateWorkspaceOverride(o)}>Customize</button>
                )}
                {o.isGrapesTemplate && templateSource(o) === "WorkspaceCustom" && props.onRevertWorkspaceOverride && (
                  <button className="btn btn-link btn-sm" onClick={() => props.onRevertWorkspaceOverride(o)}>Revert</button>
                )}
                {o.isGrapesTemplate && o.templateType === "Email" && !(templateSource(o) === "System" && props.readOnlySystemTemplates) && props.onSetGrapesDefault && (
                  <button
                    className="btn btn-link btn-sm"
                    disabled={o.isDefault}
                    title={o.isDefault ? "Default template for this event" : "Use this template by default for this event"}
                    onClick={() => props.onSetGrapesDefault(o)}
                  >
                    {o.isDefault ? "Default" : "Set default"}
                  </button>
                )}
                {o.isGrapesTemplate && !(templateSource(o) === "System" && props.readOnlySystemTemplates) && props.onDuplicateGrapesTemplate && (
                  <>
                    &nbsp;&nbsp;
                    <img
                      src={Duplicate}
                      alt="Duplicate"
                      title="Duplicate"
                      className="cursor-pointer"
                      onClick={() => props.onDuplicateGrapesTemplate(o)}
                    />
                  </>
                )}
                {!o.isGrapesTemplate && (
                  <>
                    &nbsp;&nbsp;&nbsp;
                    <img
                      src={deleteIco}
                      alt="Delete"
                      className="cursor-pointer"
                      style={{
                        opacity: templateID === o.templateId && "0.5",
                        pointerEvents: templateID === o.templateId && "none",
                      }}
                      onClick={() => deleteTemplate(o.templateId)}
                    />
                    &nbsp;&nbsp;&nbsp;
                    <img
                      src={Duplicate}
                      alt="Duplicate"
                      className="cursor-pointer opacity-50"
                      style={{
                        opacity: templateID === o.templateId && "0.5",
                        pointerEvents: templateID === o.templateId && "none",
                      }}
                      onClick={() => duplicateTemplate(o.templateId)}
                    />
                  </>
                )}
              </Col>
            </Row>
          ))}
      </div>
    </>
  );
};

export default TemplateTableList;
